export const isNameOnAccountInvalid = (
  value: string,
): boolean => {
  return /\d/.test(value);
};
